import { render, staticRenderFns } from "./MspForsageFooter.vue?vue&type=template&id=7882d2d2"
import script from "./MspForsageFooter.vue?vue&type=script&lang=js"
export * from "./MspForsageFooter.vue?vue&type=script&lang=js"
import style0 from "./MspForsageFooter.vue?vue&type=style&index=0&id=7882d2d2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports